import { createAction, props } from '@ngrx/store';

import { EntityInfoPageKeyParams } from './entity-info-page-key';

export const SET_INFO_PAGE_FILTER_TEXT = createAction(
  '[EntityInfoPage] SET_INFO_PAGE_FILTER_TEXT',
  props<{ payload: { key: EntityInfoPageKeyParams; value: { filterText: string } } }>()
);

// export const CAMPAIGN_ID_CHANGED = createAction('[ROOT: Campaign Id Changed]', props<{campaignId: string}>());
